
  
  /**
   * 이용약관 동의하기 
   * @param termsList 
   * @param type 
   */
  export const regAgreeTerms = async (termsList : number[] ,  type : string = 'PRIVACY' , snsJoinTermsYn ?: string ) => {
    
    const rootStore = useRootStore();
    const {  $sendPost } = useNuxtApp();

    const data = {
      agreeTermsList: [
        {
          termSeq: termsList
        }
      ],
      termsType: type,
      snsJoinTermsYn : snsJoinTermsYn ?? 'N' // SNS가입약관 동의여부 (Y/N) (default: N)
    };
  
    const result = await $sendPost({
      url: import.meta.env.VITE_STORE_ETC_V2_API_URL + '/terms/l1/regAgreeTerms',
      data: data,
      showDefaultLoading: false
    });
    if (result.data?.RESULT_CODE !== '0') {
      console.dir(result);
      rootStore.toast(getErrorMessage(result.data?.RESULT_CODE ?? ''));
    }
  };

/**
 * 이용약관조회
 * @param termsType 약관타입
 * @returns 
 */
  export const getTerms = async ( termsType : string): Promise<Record<string, any> | null> => {
    const rootStore = useRootStore();
    const {  $sendGet } = useNuxtApp();

    const result = await $sendGet({
      url: import.meta.env.VITE_STORE_ETC_V2_API_URL + '/terms/l2/getTerms/' + termsType,
      showDefaultLoading: false
    })
    if (result.data?.RESULT_CODE !== '0') {
      rootStore.toast(getErrorMessage(result.data?.RESULT_CODE ?? ''));
    }
    return result.data?.RESULT_CODE === '0' ? result.data?.DATA : null
  };